import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/UnitMaster.css";
import Table from "../Homepage/Table";
import AddUnitMaster from "./AddUnitMaster";
import SearchUnitMaster from "./SearchUnitMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function UnitMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Name", "Code", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [unitupdatedata, setunitupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [loading, setloading] = useState(false);
  const [excelloading, setexcelloading] = useState(false);

  const [totalcount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [unitId, setUnitId] = useState(null);

  function fetchunitdata(unitid) {
    setunitupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Unit/GetUnitByIdOrNameOrCode?id=${unitid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        setunitupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Unit/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: unitId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [x.id, x.name, x.code, x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Unit" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Unit" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Unit" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Unit" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <>
      <section className="unit-master">
        <h1>Unit Master</h1>
        <blockquote className="unit-master-forms">
          <AddMaster
            text="Add Unit Master"
            setshowaddform={setshowaddform}
            settriggerupdate={settriggerupdate}
            setshowsearchform={setshowsearchform}
            permit={writePermission}
          />

          <SearchMaster
            text="Search Unit Master"
            setshowsearchform={setshowsearchform}
            setshowaddform={setshowaddform}
          />
        </blockquote>
        {showaddform && (
          <AddUnitMaster
            setshowaddform={setshowaddform}
            reload={reload}
            setReload={setReload}
            triggerupdate={triggerupdate}
            unitupdatedata={unitupdatedata}
            key={`${unitupdatedata?.id}-${triggerupdate}-${datareload}`}
          />
        )}
        {showsearchform && (
          <SearchUnitMaster
            setshowsearchform={setshowsearchform}
            setpagenumber={setpagenumber}
            setIds={setIds}
            setUnitId={setUnitId}
            setReload={setReload}
            setSearch={setSearch}
            reload={reload}
          />
        )}
        <Table
          tablehead={tablehead}
          tabledata={tabledata}
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          fetchdata={fetchunitdata}
          url="Unit/UpdateUnit"
          reload={reload}
          setReload={setReload}
          setdatareload={setdatareload}
          datareload={datareload}
          loading={loading}
          readPermission={readPermission}
          updatePermission={updatePermission}
          deletePermission={deletePermission}
          totalcount={totalcount}
        />
        <Pagination
          count={pagecount}
          setpagenumber={setpagenumber}
          pagenumber={pagenumber}
        />
      </section>
    </>
  );
}

export default UnitMaster;
